import React, { useEffect, useState } from 'react';
import { getAuth } from 'firebase/auth';
import { getFirestore, collection, query, where, onSnapshot, doc, updateDoc, getDocs, deleteDoc, addDoc } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyDJ_lusSO40qPa2pKdvwOOexRPU2p4Vsro",
  authDomain: "tradeahv2.firebaseapp.com",
  projectId: "tradeahv2",
  storageBucket: "tradeahv2.firebasestorage.app",
  messagingSenderId: "398274404066",
  appId: "1:398274404066:web:74be764b202f62b91f08bb"
};

initializeApp(firebaseConfig);
const auth = getAuth();
const db = getFirestore();

// إعدادات الأسواق
const MARKETS = [
  { id: "EGX", name: "Egyptian Exchange", flag: "🇪🇬" },
  { id: "TADAWUL", name: "Saudi Stock Exchange", flag: "🇸🇦" },
  { id: "ADX", name: "Abu Dhabi", flag: "🇦🇪" },
  { id: "DFM", name: "Dubai", flag: "🇦🇪" },
  { id: "BKP", name: "Kuwait", flag: "🇰🇼" },
  { id: "QE", name: "Qatar", flag: "🇶🇦" },
  { id: "NASDAQ", name: "US Market", flag: "🇺🇸" }
];

// أنواع التوصيات
const SIGNAL_TYPES = [
  { id: "intraday", name: "Intraday" },
  { id: "short", name: "Short-term" },
  { id: "medium", name: "Medium-term" }
];

// فئات الأخبار
const NEWS_CATEGORIES = [
  { id: "analysis", name: "تحليل فني" },
  { id: "market_news", name: "أخبار السوق" },
  { id: "tutorial", name: "شروحات" }
];

// فئات الفيديوهات
const VIDEO_CATEGORIES = [
  { id: "beginner", name: "للمبتدئين" },
  { id: "analysis", name: "التحليل" },
  { id: "signals", name: "التوصيات" },
  { id: "advanced", name: "للمتقدمين" }
];

export default function AdminDashboard() {
  const [user, setUser] = useState(null);
  const [pendingUsers, setPendingUsers] = useState([]);
  const [allSignals, setAllSignals] = useState([]);
  const [newsItems, setNewsItems] = useState([]);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  
  // حالات النماذج
  const [activeTab, setActiveTab] = useState('users');
  const [showAddForm, setShowAddForm] = useState(false);
  const [editingSignal, setEditingSignal] = useState(null);
  const [editingNews, setEditingNews] = useState(null);
  const [editingVideo, setEditingVideo] = useState(null);
  
  // بيانات النماذج
  const [newSignal, setNewSignal] = useState({
    market: "EGX",
    ticker: "",
    ticker_name: "",
    action: "BUY",
    entry_price: "",
    stop_loss: "",
    take_profit: "",
    signal_type: "medium",
    confidence_score: 80,
    expert_id: "expert_system_01",
    analyst_id: null
  });

  const [newNews, setNewNews] = useState({
    title: "",
    summary: "",
    content: "",
    image_url: "",
    category: "analysis",
    author: "نورَ العارفين"
  });

  const [newVideo, setNewVideo] = useState({
    title: "",
    description: "",
    video_url: "",
    category: "beginner",
    thumbnail: ""
  });

  const [newNotification, setNewNotification] = useState({
    title: "",
    message: "",
    type: "global"
  });

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((currentUser) => {
      if (currentUser) {
        setUser(currentUser);
      } else {
        window.location.href = '/signup';
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!user) return;

    const fetchAllData = async () => {
      try {
        // جلب العملاء
        const usersSnapshot = await getDocs(query(collection(db, 'users'), where('trial_status', '==', 'pending')));
        const usersList = usersSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setPendingUsers(usersList);

        // جلب التوصيات
        const signalsSnapshot = await getDocs(collection(db, 'signals_v2'));
        const signalsList = signalsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setAllSignals(signalsList);

        // جلب الأخبار
        const newsSnapshot = await getDocs(collection(db, 'news'));
        const newsList = newsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setNewsItems(newsList);

        // جلب الفيديوهات
        const videosSnapshot = await getDocs(collection(db, 'videos'));
        const videosList = videosSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setVideos(videosList);

        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchAllData();
  }, [user, db]);

  const activateTrial = async (userId) => {
    try {
      const start = new Date();
      const end = new Date(start);
      end.setDate(end.getDate() + 14);
      
      await updateDoc(doc(db, 'users', userId), {
        role: "user",
        trial_status: "active",
        "subscription.start_date": start.toISOString(),
        "subscription.end_date": end.toISOString(),
        "subscription.status": "active",
        "subscription.type": "trial",
        updated_at: new Date().toISOString()
      });
      
      setMessage("✅ تم تفعيل الحساب بنجاح!");
      setTimeout(() => setMessage(""), 3000);
    } catch (error) {
      console.error("Error activating trial:", error);
      setMessage("❌ فشل تفعيل الحساب.");
    }
  };

  const handleAddNews = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const newsData = {
        ...newNews,
        is_active: true,
        published_at: new Date().toISOString()
      };
      
      await addDoc(collection(db, "news"), newsData);
      setMessage("✅ تم إضافة الخبر بنجاح!");
      setShowAddForm(false);
      setNewNews({
        title: "",
        summary: "",
        content: "",
        image_url: "",
        category: "analysis",
        author: "نورَ العارفين"
      });
      
    } catch (error) {
      console.error("Error adding news:", error);
      setMessage(`❌ خطأ: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleAddVideo = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const videoData = {
        ...newVideo,
        is_active: true,
        created_at: new Date().toISOString(),
        order: 1
      };
      
      await addDoc(collection(db, "videos"), videoData);
      setMessage("✅ تم إضافة الفيديو بنجاح!");
      setShowAddForm(false);
      setNewVideo({
        title: "",
        description: "",
        video_url: "",
        category: "beginner",
        thumbnail: ""
      });
      
    } catch (error) {
      console.error("Error adding video:", error);
        setMessage(`❌ خطأ: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleSendNotification = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const notificationData = {
        ...newNotification,
        is_active: true,
        created_at: new Date().toISOString()
      };
      
      await addDoc(collection(db, "notifications"), notificationData);
      setMessage("✅ تم إرسال الإشعار بنجاح!");
      setNewNotification({
        title: "",
        message: "",
        type: "global"
      });
      
    } catch (error) {
      console.error("Error sending notification:", error);
      setMessage(`❌ خطأ: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleAddSignal = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const entry = parseFloat(newSignal.entry_price);
      const sl = parseFloat(newSignal.stop_loss);
      const tp = parseFloat(newSignal.take_profit);
      
      if (newSignal.action === "BUY") {
        if (tp <= entry) throw new Error("الهدف يجب أن يكون أعلى من سعر الدخول");
        if (sl >= entry) throw new Error("وقف الخسارة يجب أن يكون أقل من سعر الدخول");
      } else {
        if (tp >= entry) throw new Error("الهدف يجب أن يكون أقل من سعر الدخول");
        if (sl <= entry) throw new Error("وقف الخسارة يجب أن يكون أعلى من سعر الدخول");
      }
      
      const signalData = {
        market: newSignal.market,
        ticker: newSignal.ticker,
        ticker_name: newSignal.ticker_name || newSignal.ticker,
        action: newSignal.action,
        entry_price: entry,
        stop_loss: sl,
        take_profit: tp,
        signal_type: newSignal.signal_type,
        confidence_score: parseInt(newSignal.confidence_score),
        status: "active",
        source: "manual",
        expert_id: newSignal.expert_id,
        analyst_id: newSignal.analyst_id,
        created_at: new Date().toISOString()
      };
      
      await addDoc(collection(db, "signals_v2"), signalData);
      setMessage("✅ تم إضافة التوصية بنجاح!");
      setShowAddForm(false);
      setNewSignal({
        market: "EGX",
        ticker: "",
        ticker_name: "",
        action: "BUY",
        entry_price: "",
        stop_loss: "",
        take_profit: "",
        signal_type: "medium",
        confidence_score: 80,
        expert_id: "expert_system_01",
        analyst_id: null
      });
      
    } catch (error) {
      console.error("Error adding signal:", error);
      setMessage(`❌ خطأ: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const startEdit = (signal) => {
    setEditingSignal({ ...signal });
    setShowAddForm(false);
    setActiveTab('signals');
  };

  const handleSaveEdit = async () => {
    if (!editingSignal) return;
    
    try {
      const entry = parseFloat(editingSignal.entry_price);
      const sl = parseFloat(editingSignal.stop_loss);
      const tp = parseFloat(editingSignal.take_profit);
      
      if (editingSignal.action === "BUY") {
        if (tp <= entry) throw new Error("الهدف يجب أن يكون أعلى من سعر الدخول");
        if (sl >= entry) throw new Error("وقف الخسارة يجب أن يكون أقل من سعر الدخول");
      } else {
        if (tp >= entry) throw new Error("الهدف يجب أن يكون أقل من سعر الدخول");
        if (sl <= entry) throw new Error("وقف الخسارة يجب أن يكون أعلى من سعر الدخول");
      }
      
      await updateDoc(doc(db, 'signals_v2', editingSignal.id), {
        entry_price: entry,
        stop_loss: sl,
        take_profit: tp,
        signal_type: editingSignal.signal_type,
        confidence_score: parseInt(editingSignal.confidence_score),
        ticker_name: editingSignal.ticker_name || editingSignal.ticker
      });
      
      setEditingSignal(null);
      setMessage("✅ تم تحديث التوصية بنجاح!");
      setTimeout(() => setMessage(""), 3000);
      
    } catch (error) {
      console.error("Error updating signal:", error);
      setMessage(`❌ خطأ: ${error.message}`);
    }
  };

  const handleDelete = async (signalId) => {
    if (window.confirm('هل أنت متأكد من حذف هذه التوصية؟')) {
      try {
        await deleteDoc(doc(db, 'signals_v2', signalId));
        setMessage("✅ تم حذف التوصية بنجاح!");
        setTimeout(() => setMessage(""), 3000);
      } catch (error) {
        console.error("Error deleting signal:", error);
        setMessage("❌ فشل حذف التوصية.");
      }
    }
  };

  const handleDeleteNews = async (newsId) => {
    if (window.confirm('هل أنت متأكد من حذف هذا الخبر؟')) {
      try {
        await deleteDoc(doc(db, 'news', newsId));
        setMessage("✅ تم حذف الخبر بنجاح!");
        setTimeout(() => setMessage(""), 3000);
      } catch (error) {
        console.error("Error deleting news:", error);
        setMessage("❌ فشل حذف الخبر.");
      }
    }
  };

  const handleDeleteVideo = async (videoId) => {
    if (window.confirm('هل أنت متأكد من حذف هذا الفيديو؟')) {
      try {
        await deleteDoc(doc(db, 'videos', videoId));
        setMessage("✅ تم حذف الفيديو بنجاح!");
        setTimeout(() => setMessage(""), 3000);
      } catch (error) {
        console.error("Error deleting video:", error);
        setMessage("❌ فشل حذف الفيديو.");
      }
    }
  };

  if (loading && !showAddForm) {
    return <div style={{ padding: '20px' }}>Loading...</div>;
  }

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <h2 style={{ color: '#1e40af', textAlign: 'center', marginBottom: '24px' }}>
        لوحة التحكم - TradeAH (المدير)
      </h2>
      
      {message && (
        <div style={{ 
          padding: '12px', 
          borderRadius: '8px', 
          backgroundColor: message.includes('✅') ? '#f0fdf4' : '#fef2f2',
          color: message.includes('✅') ? '#166534' : '#b91c1c',
          marginBottom: '20px',
          border: message.includes('✅') ? '1px solid #bbf7d0' : '1px solid #fecaca'
        }}>
          {message}
        </div>
      )}

      <div style={{ 
        display: 'flex', 
        gap: '12px', 
        marginBottom: '24px',
        flexWrap: 'wrap'
      }}>
        <button
          onClick={() => setActiveTab('users')}
          style={{
            padding: '10px 16px',
            backgroundColor: activeTab === 'users' ? '#1e40af' : '#e2e8f0',
            color: activeTab === 'users' ? 'white' : '#1e293b',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          العملاء
        </button>
        <button
          onClick={() => setActiveTab('signals')}
          style={{
            padding: '10px 16px',
            backgroundColor: activeTab === 'signals' ? '#1e40af' : '#e2e8f0',
            color: activeTab === 'signals' ? 'white' : '#1e293b',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          التوصيات
        </button>
        <button
          onClick={() => {
            setActiveTab('news');
            setShowAddForm(true);
          }}
          style={{
            padding: '10px 16px',
            backgroundColor: activeTab === 'news' ? '#1e40af' : '#e2e8f0',
            color: activeTab === 'news' ? 'white' : '#1e293b',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          الأخبار
        </button>
        <button
          onClick={() => {
            setActiveTab('videos');
            setShowAddForm(true);
          }}
          style={{
            padding: '10px 16px',
            backgroundColor: activeTab === 'videos' ? '#1e40af' : '#e2e8f0',
            color: activeTab === 'videos' ? 'white' : '#1e293b',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          الفيديوهات
        </button>
        <button
          onClick={() => {
            setActiveTab('notifications');
            setShowAddForm(true);
          }}
          style={{
            padding: '10px 16px',
            backgroundColor: activeTab === 'notifications' ? '#1e40af' : '#e2e8f0',
            color: activeTab === 'notifications' ? 'white' : '#1e293b',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          الإشعارات
        </button>
      </div>

      {activeTab === 'users' && (
        <>
          <h3 style={{ marginBottom: '16px', color: '#1e40af' }}>
            العملاء قيد الانتظار ({pendingUsers.length})
          </h3>
          
          {pendingUsers.length === 0 ? (
            <div style={{ 
              textAlign: 'center', 
              padding: '40px', 
              backgroundColor: 'white', 
              borderRadius: '12px',
              border: '1px dashed #cbd5e1'
            }}>
              <p>لا توجد طلبات تفعيل جديدة</p>
            </div>
          ) : (
            <div style={{ display: 'grid', gap: '16px' }}>
              {pendingUsers.map(user => (
                <div key={user.id} style={{ 
                  padding: '16px', 
                  border: '1px solid #e2e8f0', 
                  borderRadius: '8px',
                  backgroundColor: '#f8fafc'
                }}>
                  <h4>{user.first_name} {user.last_name}</h4>
                  <p><strong>البريد:</strong> {user.email}</p>
                  <p><strong>السوق:</strong> {user.subscribed_markets.join(', ')}</p>
                  <p><strong>التاريخ:</strong> {new Date(user.created_at).toLocaleDateString('ar-EG')}</p>
                  <button 
                    onClick={() => activateTrial(user.id)}
                    style={{
                      backgroundColor: '#10b981',
                      color: 'white',
                      border: 'none',
                      padding: '8px 16px',
                      borderRadius: '6px',
                      cursor: 'pointer'
                    }}
                  >
                    تفعيل الحساب
                  </button>
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {/* باقي الكود... */}
      
      {/* تبويب التوصيات */}
      {activeTab === 'signals' && (
        <div>
          <div style={{ display: 'flex', gap: '12px', marginBottom: '24px' }}>
            <button
              onClick={() => setShowAddForm(!showAddForm)}
              style={{
                backgroundColor: '#1e40af',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              {showAddForm ? 'إلغاء' : 'إضافة توصية'}
            </button>
            <button
              onClick={() => window.location.reload()}
              style={{
                backgroundColor: '#64748b',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              تحديث البيانات
            </button>
          </div>

          {/* نموذج إضافة/تعديل توصية */}
          {(showAddForm || editingSignal) && (
            <div style={{ 
              backgroundColor: 'white', 
              padding: '24px', 
              borderRadius: '12px',
              border: '1px solid #e2e8f0',
              marginBottom: '24px'
            }}>
              <h3 style={{ color: '#1e40af', marginBottom: '16px' }}>
                {editingSignal ? 'تعديل التوصية' : 'إضافة توصية جديدة'}
              </h3>
              
              {editingSignal ? (
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', marginBottom: '20px' }}>
                  <div>
                    <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                      سعر الدخول
                    </label>
                    <input
                      type="number"
                      value={editingSignal.entry_price}
                      onChange={(e) => setEditingSignal({ ...editingSignal, entry_price: e.target.value })}
                      step="0.01"
                      style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                    />
                  </div>
                  <div>
                    <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                      وقف الخسارة
                    </label>
                    <input
                      type="number"
                      value={editingSignal.stop_loss}
                      onChange={(e) => setEditingSignal({ ...editingSignal, stop_loss: e.target.value })}
                      step="0.01"
                      style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                    />
                  </div>
                  <div>
                    <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                      الهدف
                    </label>
                    <input
                      type="number"
                      value={editingSignal.take_profit}
                      onChange={(e) => setEditingSignal({ ...editingSignal, take_profit: e.target.value })}
                      step="0.01"
                      style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '4px' }}
                    />
                  </div>
                </div>
              ) : (
                <form onSubmit={handleAddSignal}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '16px', marginBottom: '16px' }}>
                    <div>
                      <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                        السوق
                      </label>
                      <select
                        value={newSignal.market}
                        onChange={(e) => setNewSignal({ ...newSignal, market: e.target.value })}
                        style={{
                          width: '100%',
                          padding: '10px',
                          border: '1px solid #ddd',
                          borderRadius: '6px'
                        }}
                      >
                        {MARKETS.map(market => (
                          <option key={market.id} value={market.id}>
                            {market.flag} {market.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                        رمز السهم
                      </label>
                      <input
                        type="text"
                        value={newSignal.ticker}
                        onChange={(e) => setNewSignal({ ...newSignal, ticker: e.target.value })}
                        required
                        style={{
                          width: '100%',
                          padding: '10px',
                          border: '1px solid #ddd',
                          borderRadius: '6px'
                        }}
                      />
                    </div>
                  </div>
                  
                  <div style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                      اسم السهم (اختياري)
                    </label>
                    <input
                      type="text"
                      value={newSignal.ticker_name}
                      onChange={(e) => setNewSignal({ ...newSignal, ticker_name: e.target.value })}
                      style={{
                        width: '100%',
                        padding: '10px',
                        border: '1px solid #ddd',
                        borderRadius: '6px'
                      }}
                    />
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                    <div>
                      <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                        الاتجاه
                      </label>
                      <div style={{ display: 'flex', gap: '12px' }}>
                        <label style={{ 
                          padding: '8px 16px', 
                          border: newSignal.action === 'BUY' ? '2px solid #16a34a' : '1px solid #ddd',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          backgroundColor: newSignal.action === 'BUY' ? '#dcfce7' : 'white'
                        }}>
                          <input
                            type="radio"
                            name="action"
                            value="BUY"
                            checked={newSignal.action === 'BUY'}
                            onChange={(e) => setNewSignal({ ...newSignal, action: e.target.value })}
                            style={{ display: 'none' }}
                          />
                          شراء
                        </label>
                        <label style={{ 
                          padding: '8px 16px', 
                          border: newSignal.action === 'SELL' ? '2px solid #dc2626' : '1px solid #ddd',
                          borderRadius: '6px',
                          cursor: 'pointer',
                          backgroundColor: newSignal.action === 'SELL' ? '#fef2f2' : 'white'
                        }}>
                          <input
                            type="radio"
                            name="action"
                            value="SELL"
                            checked={newSignal.action === 'SELL'}
                            onChange={(e) => setNewSignal({ ...newSignal, action: e.target.value })}
                            style={{ display: 'none' }}
                          />
                          بيع
                        </label>
                      </div>
                    </div>
                    <div>
                      <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                        نوع التوصية
                      </label>
                      <select
                        value={newSignal.signal_type}
                        onChange={(e) => setNewSignal({ ...newSignal, signal_type: e.target.value })}
                        style={{
                          width: '100%',
                          padding: '10px',
                          border: '1px solid #ddd',
                          borderRadius: '6px'
                        }}
                      >
                        {SIGNAL_TYPES.map(type => (
                          <option key={type.id} value={type.id}>{type.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', marginBottom: '24px' }}>
                    <div>
                      <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                        سعر الدخول *
                      </label>
                      <input
                        type="number"
                        value={newSignal.entry_price}
                        onChange={(e) => setNewSignal({ ...newSignal, entry_price: e.target.value })}
                        required
                        step="0.01"
                        min="0"
                        style={{
                          width: '100%',
                          padding: '10px',
                          border: '1px solid #ddd',
                          borderRadius: '6px'
                        }}
                      />
                    </div>
                    <div>
                      <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                        وقف الخسارة *
                      </label>
                      <input
                        type="number"
                        value={newSignal.stop_loss}
                        onChange={(e) => setNewSignal({ ...newSignal, stop_loss: e.target.value })}
                        required
                        step="0.01"
                        min="0"
                        style={{
                          width: '100%',
                          padding: '10px',
                          border: '1px solid #ddd',
                          borderRadius: '6px'
                        }}
                      />
                    </div>
                    <div>
                      <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                        الهدف *
                      </label>
                      <input
                        type="number"
                        value={newSignal.take_profit}
                        onChange={(e) => setNewSignal({ ...newSignal, take_profit: e.target.value })}
                        required
                        step="0.01"
                        min="0"
                        style={{
                          width: '100%',
                          padding: '10px',
                          border: '1px solid #ddd',
                          borderRadius: '6px'
                        }}
                      />
                    </div>
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px' }}>
                    <div>
                      <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                        درجة الثقة (%)
                      </label>
                      <input
                        type="range"
                        min="1"
                        max="100"
                        value={newSignal.confidence_score}
                        onChange={(e) => setNewSignal({ ...newSignal, confidence_score: e.target.value })}
                        style={{ width: '100%' }}
                      />
                      <div style={{ textAlign: 'center', fontWeight: 'bold', marginTop: '4px' }}>
                        {newSignal.confidence_score}%
                      </div>
                    </div>
                    <div>
                      <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                        الخبير
                      </label>
                      <select
                        value={newSignal.expert_id}
                        onChange={(e) => setNewSignal({ ...newSignal, expert_id: e.target.value })}
                        style={{
                          width: '100%',
                          padding: '10px',
                          border: '1px solid #ddd',
                          borderRadius: '6px'
                        }}
                      >
                        <option value="expert_system_01">TradeAH_System</option>
                        <option value="expert_01">TradeAH_01</option>
                        <option value="expert_02">TradeAH_02</option>
                      </select>
                    </div>
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    style={{
                      width: '100%',
                      padding: '12px',
                      backgroundColor: '#1e40af',
                      color: 'white',
                      border: 'none',
                      borderRadius: '6px',
                      fontSize: '16px',
                      cursor: loading ? 'not-allowed' : 'pointer'
                    }}
                  >
                    {loading ? 'جاري الإضافة...' : 'إضافة التوصية'}
                  </button>
                </form>
              )}

              {editingSignal && (
                <div style={{ display: 'flex', gap: '12px' }}>
                  <button
                    onClick={handleSaveEdit}
                    style={{
                      backgroundColor: '#1e40af',
                      color: 'white',
                      border: 'none',
                      padding: '10px 20px',
                      borderRadius: '6px',
                      cursor: 'pointer'
                    }}
                  >
                    حفظ التعديلات
                  </button>
                  <button
                    onClick={() => setEditingSignal(null)}
                    style={{
                      backgroundColor: '#64748b',
                      color: 'white',
                      border: 'none',
                      padding: '10px 20px',
                      borderRadius: '6px',
                      cursor: 'pointer'
                    }}
                  >
                    إلغاء
                  </button>
                </div>
              )}
            </div>
          )}

          {/* عرض التوصيات */}
          <h3 style={{ marginBottom: '16px', color: '#1e40af' }}>
            جميع التوصيات ({allSignals.length})
          </h3>
          
          {allSignals.length === 0 ? (
            <div style={{ 
              textAlign: 'center', 
              padding: '20px', 
              backgroundColor: 'white', 
              borderRadius: '8px',
              border: '1px dashed #cbd5e1'
            }}>
              <p>لا توجد توصيات</p>
            </div>
          ) : (
            <div style={{ display: 'grid', gap: '12px' }}>
              {allSignals.map(signal => (
                <div key={signal.id} style={{ 
                  padding: '12px', 
                  border: '1px solid #e2e8f0', 
                  borderRadius: '6px',
                  backgroundColor: signal.status === 'active' ? '#f0f9ff' : '#fef2f2'
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div>
                      <strong>{signal.action} {signal.ticker}</strong> 
                      {signal.ticker_name && `(${signal.ticker_name})`}
                      <div style={{ fontSize: '14px', color: '#64748b' }}>
                        {signal.expert_id ? `الخبير: ${signal.expert_id}` : 'نظام آلي'} | 
                        النوع: {signal.signal_type} | 
                        الثقة: {signal.confidence_score}%
                      </div>
                    </div>
                    <div>
                      <button 
                        onClick={() => startEdit(signal)}
                        style={{
                          backgroundColor: '#1e40af',
                          color: 'white',
                          border: 'none',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          fontSize: '12px',
                          marginRight: '6px'
                        }}
                      >
                        تعديل
                      </button>
                      <button 
                        onClick={() => handleDelete(signal.id)}
                        style={{
                          backgroundColor: '#dc2626',
                          color: 'white',
                          border: 'none',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          fontSize: '12px'
                        }}
                      >
                        حذف
                      </button>
                    </div>
                  </div>
                  <div style={{ fontSize: '14px', marginTop: '8px' }}>
                    <span style={{ color: '#64748b' }}>الدخول:</span> {signal.entry_price} | 
                    <span style={{ color: '#64748b' }}>الهدف:</span> {signal.take_profit} | 
                    <span style={{ color: '#64748b' }}>وقف:</span> {signal.stop_loss}
                    {signal.status !== 'active' && (
                      <span style={{ color: signal.status === 'achieved' ? '#16a34a' : '#dc2626', marginLeft: '8px' }}>
                        {signal.status === 'achieved' ? '✓ ناجحة' : '✗ خاسرة'}
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* تبويب الأخبار */}
      {activeTab === 'news' && (
        <div>
          {!showAddForm ? (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '24px' }}>
                <h3 style={{ color: '#1e40af', margin: 0 }}>الأخبار ({newsItems.length})</h3>
                <button
                  onClick={() => setShowAddForm(true)}
                  style={{
                    backgroundColor: '#1e40af',
                    color: 'white',
                    border: 'none',
                    padding: '8px 16px',
                    borderRadius: '6px',
                    cursor: 'pointer'
                  }}
                >
                  إضافة خبر
                </button>
              </div>
              
              {newsItems.length === 0 ? (
                <div style={{ 
                  textAlign: 'center', 
                  padding: '40px', 
                  backgroundColor: 'white', 
                  borderRadius: '12px',
                  border: '1px dashed #cbd5e1'
                }}>
                  <p>لا توجد أخبار</p>
                </div>
              ) : (
                <div style={{ display: 'grid', gap: '16px' }}>
                  {newsItems.map(item => (
                    <div key={item.id} style={{ 
                      padding: '16px', 
                      border: '1px solid #e2e8f0', 
                      borderRadius: '8px',
                      backgroundColor: '#f8fafc'
                    }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <h4 style={{ margin: '0 0 8px 0', color: '#0f172a' }}>{item.title}</h4>
                        <div>
                          <button 
                            onClick={() => {
                              setEditingNews(item);
                              setShowAddForm(true);
                            }}
                            style={{
                              backgroundColor: '#1e40af',
                              color: 'white',
                              border: 'none',
                              padding: '4px 8px',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '12px',
                              marginRight: '6px'
                            }}
                          >
                            تعديل
                          </button>
                          <button 
                            onClick={() => handleDeleteNews(item.id)}
                            style={{
                              backgroundColor: '#dc2626',
                              color: 'white',
                              border: 'none',
                              padding: '4px 8px',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '12px'
                            }}
                          >
                            حذف
                          </button>
                        </div>
                      </div>
                      <p style={{ margin: '0 0 8px 0', color: '#64748b' }}>{item.summary}</p>
                      <div style={{ fontSize: '14px', color: '#64748b' }}>
                        <span>الكاتب: {item.author}</span> | 
                        <span>التصنيف: {item.category === 'analysis' ? 'تحليل' : item.category === 'market_news' ? 'أخبار' : 'شرح'}</span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          ) : (
            <div style={{ 
              backgroundColor: 'white', 
              padding: '24px', 
              borderRadius: '12px',
              border: '1px solid #e2e8f0'
            }}>
              <h3 style={{ color: '#1e40af', marginBottom: '16px' }}>
                {editingNews ? 'تعديل الخبر' : 'إضافة خبر جديد'}
              </h3>
              
              <form onSubmit={editingNews ? (e) => {
                e.preventDefault();
                const updatedNews = {
                  ...editingNews,
                  is_active: true,
                  published_at: editingNews.published_at || new Date().toISOString()
                };
                updateDoc(doc(db, 'news', editingNews.id), updatedNews);
                setEditingNews(null);
                setShowAddForm(false);
                setMessage("✅ تم تحديث الخبر بنجاح!");
              } : handleAddNews}>
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                    العنوان *
                  </label>
                  <input
                    type="text"
                    value={editingNews ? editingNews.title : newNews.title}
                    onChange={(e) => editingNews ? 
                      setEditingNews({ ...editingNews, title: e.target.value }) : 
                      setNewNews({ ...newNews, title: e.target.value })
                    }
                    required
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #ddd',
                      borderRadius: '6px'
                    }}
                  />
                </div>
                
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                    الملخص *
                  </label>
                  <textarea
                    value={editingNews ? editingNews.summary : newNews.summary}
                    onChange={(e) => editingNews ? 
                      setEditingNews({ ...editingNews, summary: e.target.value }) : 
                      setNewNews({ ...newNews, summary: e.target.value })
                    }
                    required
                    rows="3"
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #ddd',
                      borderRadius: '6px'
                    }}
                  />
                </div>
                
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                    المحتوى الكامل (HTML)
                  </label>
                  <textarea
                    value={editingNews ? editingNews.content : newNews.content}
                    onChange={(e) => editingNews ? 
                      setEditingNews({ ...editingNews, content: e.target.value }) : 
                      setNewNews({ ...newNews, content: e.target.value })
                    }
                    rows="6"
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #ddd',
                      borderRadius: '6px'
                    }}
                  />
                </div>
                
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                  <div>
                    <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                      رابط الصورة
                    </label>
                    <input
                      type="text"
                      value={editingNews ? editingNews.image_url : newNews.image_url}
                      onChange={(e) => editingNews ? 
                        setEditingNews({ ...editingNews, image_url: e.target.value }) : 
                        setNewNews({ ...newNews, image_url: e.target.value })
                      }
                      style={{
                        width: '100%',
                        padding: '10px',
                        border: '1px solid #ddd',
                        borderRadius: '6px'
                      }}
                    />
                  </div>
                  <div>
                    <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                      التصنيف
                    </label>
                    <select
                      value={editingNews ? editingNews.category : newNews.category}
                      onChange={(e) => editingNews ? 
                        setEditingNews({ ...editingNews, category: e.target.value }) : 
                        setNewNews({ ...newNews, category: e.target.value })
                      }
                      style={{
                        width: '100%',
                        padding: '10px',
                        border: '1px solid #ddd',
                        borderRadius: '6px'
                      }}
                    >
                      {NEWS_CATEGORIES.map(cat => (
                        <option key={cat.id} value={cat.id}>{cat.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
                
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                    الكاتب
                  </label>
                  <input
                    type="text"
                    value={editingNews ? editingNews.author : newNews.author}
                    onChange={(e) => editingNews ? 
                      setEditingNews({ ...editingNews, author: e.target.value }) : 
                      setNewNews({ ...newNews, author: e.target.value })
                    }
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #ddd',
                      borderRadius: '6px'
                    }}
                  />
                </div>
                
                <button
                  type="submit"
                  disabled={loading}
                  style={{
                    width: '100%',
                    padding: '12px',
                    backgroundColor: '#1e40af',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    fontSize: '16px',
                    cursor: loading ? 'not-allowed' : 'pointer'
                  }}
                >
                  {loading ? 'جاري الحفظ...' : (editingNews ? 'حفظ التعديلات' : 'إضافة الخبر')}
                </button>
                
                <button
                  type="button"
                  onClick={() => {
                    setShowAddForm(false);
                    setEditingNews(null);
                  }}
                  style={{
                    marginTop: '12px',
                    width: '100%',
                    padding: '12px',
                    backgroundColor: '#64748b',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6x',
                    fontSize: '16px',
                    cursor: 'pointer'
                  }}
                >
                  إلغاء
                </button>
              </form>
            </div>
          )}
        </div>
      )}

      {/* تبويب الفيديوهات */}
      {activeTab === 'videos' && (
        <div>
          {!showAddForm ? (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '24px' }}>
                <h3 style={{ color: '#1e40af', margin: 0 }}>الفيديوهات ({videos.length})</h3>
                <button
                  onClick={() => setShowAddForm(true)}
                  style={{
                    backgroundColor: '#1e40af',
                    color: 'white',
                    border: 'none',
                    padding: '8px 16px',
                    borderRadius: '6px',
                    cursor: 'pointer'
                  }}
                >
                 افة فيديو
                </button>
              </div>
              
              {videos.length === 0 ? (
                <div style={{ 
                  textAlign: 'center', 
                  padding: '40px', 
                  backgroundColor: 'white', 
                  borderRadius: '12px',
                  border: '1px dashed #cbd5e1'
                }}>
                  <p>لا توجد فيديوهات</p>
                </div>
              ) : (
                <div style={{ display: 'grid', gap: '16px' }}>
                  {videos.map(video => (
                    <div key={video.id} style={{ 
                      padding: '16px', 
                      border: '1px solid #e2e8f0', 
                      borderRadius: '8px',
                      backgroundColor: '#f8fafc'
                    }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <h4 style={{ margin: '0 0 8px 0', color: '#0f172a' }}>{video.title}</h4>
                        <div>
                          <button 
                            onClick={() => {
                              setEditingVideo(video);
                              setShowAddForm(true);
                            }}
                            style={{
                              backgroundColor: '#1e40af',
                              color: 'white',
                              border: 'none',
                              padding: '4px 8px',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '12px',
                              marginRight: '6px'
                            }}
                          >
                            تعديل
                          </button>
                          <button 
                            onClick={() => handleDeleteVideo(video.id)}
                            style={{
                              backgroundColor: '#dc2626',
                              color: 'white',
                              border: 'none',
                              padding: '4px 8px',
                              borderRadius: '4px',
                              cursor: 'pointer',
                              fontSize: '12px'
                            }}
                          >
                            حذف
                          </button>
                        </div>
                      </div>
                      <p style={{ margin: '0 0 8px 0', color: '#64748b' }}>{video.description}</p>
                      <div style={{ fontSize: '14px', color: '#64748b' }}>
                        <span>التصنيف: {video.category === 'beginner' ? 'للمبتدئين' : video.category === 'analysis' ? 'التحليل' : video.category === 'signals' ? 'التوصيات' : 'للمتقدمين'}</span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          ) : (
            <div style={{ 
              backgroundColor: 'white', 
              padding: '24px', 
              borderRadius: '12px',
              border: '1px solid #e2e8f0'
            }}>
              <h3 style={{ color: '#1e40af', marginBottom: '16px' }}>
                {editingVideo ? 'تعديل الفيديو' : 'إضافة فيديو جديد'}
              </h3>
              
              <form onSubmit={editingVideo ? (e) => {
                e.preventDefault();
                const updatedVideo = {
                  ...editingVideo,
                  is_active: true,
                  created_at: editingVideo.created_at || new Date().toISOString()
                };
                updateDoc(doc(db, 'videos', editingVideo.id), updatedVideo);
                setEditingVideo(null);
                setShowAddForm(false);
                setMessage("✅ تم تحديث الفيديو بنجاح!");
              } : handleAddVideo}>
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                    العنوان *
                  </label>
                  <input
                    type="text"
                    value={editingVideo ? editingVideo.title : newVideo.title}
                    onChange={(e) => editingVideo ? 
                      setEditingVideo({ ...editingVideo, title: e.target.value }) : 
                      setNewVideo({ ...newVideo, title: e.target.value })
                    }
                    required
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #ddd',
                      borderRadius: '6px'
                    }}
                  />
                </div>
                
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                    الوصف *
                  </label>
                  <textarea
                    value={editingVideo ? editingVideo.description : newVideo.description}
                    onChange={(e) => editingVideo ? 
                      setEditingVideo({ ...editingVideo, description: e.target.value }) : 
                      setNewVideo({ ...newVideo, description: e.target.value })
                    }
                    required
                    rows="3"
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #ddd',
                      borderRadius: '6px'
                    }}
                  />
                </div>
                
                <div style={{ marginBottom: '16px' }}>
                  <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                    رابط الفيديو (YouTube) *
                  </label>
                  <input
                    type="text"
                    value={editingVideo ? editingVideo.video_url : newVideo.video_url}
                    onChange={(e) => editingVideo ? 
                      setEditingVideo({ ...editingVideo, video_url: e.target.value }) : 
                      setNewVideo({ ...newVideo, video_url: e.target.value })
                    }
                    required
                    placeholder="https://www.youtube.com/watch?v=..."
                    style={{
                      width: '100%',
                      padding: '10px',
                      border: '1px solid #ddd',
                      borderRadius: '6px'
                    }}
                  />
                </div>
                
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                  <div>
                    <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                      رابط الصورة المصغرة (اختياري)
                    </label>
                    <input
                      type="text"
                      value={editingVideo ? editingVideo.thumbnail : newVideo.thumbnail}
                      onChange={(e) => editingVideo ? 
                        setEditingVideo({ ...editingVideo, thumbnail: e.target.value }) : 
                        setNewVideo({ ...newVideo, thumbnail: e.target.value })
                      }
                      placeholder="https://i.ytimg.com/vi/VIDEO_ID/hqdefault.jpg"
                      style={{
                        width: '100%',
                        padding: '10px',
                        border: '1px solid #ddd',
                        borderRadius: '6px'
                      }}
                    />
                  </div>
                  <div>
                    <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                      التصنيف
                    </label>
                    <select
                      value={editingVideo ? editingVideo.category : newVideo.category}
                      onChange={(e) => editingVideo ? 
                        setEditingVideo({ ...editingVideo, category: e.target.value }) : 
                        setNewVideo({ ...newVideo, category: e.target.value })
                      }
                      style={{
                        width: '100%',
                        padding: '10px',
                        border: '1px solid #ddd',
                        borderRadius: '6px'
                      }}
                    >
                      {VIDEO_CATEGORIES.map(cat => (
                        <option key={cat.id} value={cat.id}>{cat.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
                
                <button
                  type="submit"
                  disabled={loading}
                  style={{
                    width: '100%',
                    padding: '12px',
                    backgroundColor: '#1e40af',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    fontSize: '16px',
                    cursor: loading ? 'not-allowed' : 'pointer'
                  }}
                >
                  {loading ? 'جاري الحفظ...' : (editingVideo ? 'حفظ التعديلات' : 'إضافة الفيديو')}
                </button>
                
                <button
                  type="button"
                  onClick={() => {
                    setShowAddForm(false);
                    setEditingVideo(null);
                  }}
                  style={{
                    marginTop: '12px',
                    width: '100%',
                    padding: '12px',
                    backgroundColor: '#64748b',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    fontSize: '16px',
                    cursor: 'pointer'
                  }}
                >
                  إلغاء
                </button>
              </form>
            </div>
          )}
        </div>
      )}

      {activeTab === 'notifications' && (
        <div style={{ 
          backgroundColor: 'white', 
          padding: '24px', 
          borderRadius: '12px',
          border: '1px solid #e2e8f0'
        }}>
          <h3 style={{ color: '#1e40af', marginBottom: '16px' }}>
            إرسال إشعار جديد
          </h3>
          
          <form onSubmit={handleSendNotification}>
            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                العنوان (اختياري)
              </label>
              <input
                type="text"
                value={newNotification.title}
                onChange={(e) => setNewNotification({ ...newNotification, title: e.target.value })}
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '6px'
                }}
              />
            </div>
            
            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                الرسالة *
              </label>
              <textarea
                value={newNotification.message}
                onChange={(e) => setNewNotification({ ...newNotification, message: e.target.value })}
                required
                rows="4"
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '6px'
                }}
              />
            </div>
            
            <div style={{ marginBottom: '24px' }}>
              <label style={{ display: 'block', marginBottom: '6px', fontWeight: '500' }}>
                نوع الإشعار
              </label>
              <div style={{ display: 'flex', gap: '12px' }}>
                <label style={{ 
                  padding: '8px 16px', 
                  border: newNotification.type === 'global' ? '2px solid #1e40af' : '1px solid #ddd',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  backgroundColor: newNotification.type === 'global' ? '#eff6ff' : 'white'
                }}>
                  <input
                    type="radio"
                    name="notificationType"
                    value="global"
                    checked={newNotification.type === 'global'}
                    onChange={(e) => setNewNotification({ ...newNotification, type: e.target.value })}
                    style={{ display: 'none' }}
                  />
                  لجميع العملاء
                </label>
                <label style={{ 
                  padding: '8px 16px', 
                  border: newNotification.type === 'user' ? '2px solid #dc2626' : '1px solid #ddd',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  backgroundColor: newNotification.type === 'user' ? '#fef2f2' : 'white'
                }}>
                  <input
                    type="radio"
                    name="notificationType"
                    value="user"
                    checked={newNotification.type === 'user'}
                    onChange={(e) => setNewNotification({ ...newNotification, type: e.target.value })}
                    style={{ display: 'none' }}
                  />
                  لعميل محدد
                </label>
              </div>
            </div>
            
            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: '#1e40af',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontSize: '16px',
                cursor: loading ? 'not-allowed' : 'pointer'
              }}
            >
              {loading ? 'جاري الإرسال...' : 'إرسال الإشعار'}
            </button>
          </form>
        </div>
      )}
    </div>
  );
}

